import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { RatingInfoComponent } from 'src/app/components/rating-info/rating-info.component';
import { AreaManagementService } from 'src/app/services/area-management/area-management.service';
import { LhFirebaseService } from 'src/app/services/fire/lh-fire.service';
import * as _ from 'lodash';
import { groupBy, map, mergeMap, reduce, toArray } from 'rxjs/operators';
import { of } from 'rxjs';
import { Device } from '@capacitor/device';
import { SiteRatingComponent } from 'src/app/components/site-rating/site-rating.component';
import { limit, orderBy, startAfter, where } from '@angular/fire/firestore';
@Component({
    selector: 'app-industrial-welfare-screen',
    templateUrl: './industrial-welfare-screen.page.html',
    styleUrls: ['./industrial-welfare-screen.page.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class IndustrialWelfareScreenPage extends BaseInjectorService implements OnInit {
  pageTitle = this.translate.instant('Welfare and HK review');
  //btnTitle = this.translate.instant('BOG_TOUR.BTN_ABORTBOGTOUR');
  showBackBtn = true;
  headerHeight:any;
  defaultUrl = '/house-keeping-review';
  showFirstIcon = true;
  showSecondIcon = true;
  firstIconName = 'notifications-outline'
  secondIconName = 'person-circle';
  iconPosition = 'end';
  typeName: any;
  plantList: any;
  showIcon: boolean=true;
  areaNameList: any[]=[];
  areaZoneList: any[]=[];
  siteNameList: any[]=[];
  submittedDate: any;
  areaWiseRatingList: any[]=[];
  sortingLabel: string;
  userRoleType: any;
  areaZoneListCopy: any[]=[];
  type:any;
  ratingTypeList:any[];
  siteNameListCopy: any[]=[];
  areaNameListCopy: any[]=[];
  areaUnitList: any[]=[];
  areaUnitListCopy: any[]=[];
  areaCountryList: any[]=[];
  areaCountryListCopy: any[]=[];
  showSubmittedRatingError: boolean;
  areaWiseRatingListCopy: any[]=[];
  plantNameList:any[];
  plantWiseRating: any[]=[];
  last_document: any[]=[];
  isAreaLoaded: boolean;
  isMySitedataLoaded: boolean;
  paginationData: any[]=[];
  constructor(private route:ActivatedRoute,
    private areaService:AreaManagementService,
    private lhFirebaseService: LhFirebaseService,public service:AppService,) {
    super() 
  }

  async ngOnInit() {
        this.typeName=this.type;
        this.userRoleType=this.userRoleType;
        if ( this.platform.is('ios') ) {
          const deviceInfo: any = await Device.getInfo();
          const deviceNum=deviceInfo.model.split('iPhone')[1].trim();
          let deviceModel=deviceNum.slice(0, 2);
          if(deviceModel > 10){
            this.headerHeight='110px';
          }else{
            this.headerHeight='90px';
          }
          // this.headerHeight='120px';
        } else if(this.platform.is('android')){
          this.headerHeight='90px';
        }else{
          this.headerHeight='90px';
        }
  }
  async ionViewWillEnter(){
    this.areaWiseRatingList=[];
    this.plantWiseRating=[];
    this.sortingLabel='Site';
    this.plantNameList.forEach(data => {
      this.ratingTypeList.forEach(element => {
        if(data.name==element.plant_name){
        element['new_avg_rating']=parseFloat(element.avg_rating);
        const str=(element.area_name).split('- ');
          element['full_name']=str[1];
          const zone_num=(element.zone_name).split(' ');
          element['zone_num']=Number(zone_num[1]);
        this.areaZoneList.push({check: true, name: element.zone_name, selected: false, order_number: element.zone_num});
        this.areaZoneListCopy.push({check: true, name: element.zone_name, selected: false, order_number: element.zone_num});
        this.areaNameList.push({check: true, name: element.full_name, selected: false, full_name: element.area_name});
        this.areaNameListCopy.push({check: true, name: element.full_name, selected: false, full_name: element.area_name});
        this.siteNameList.push({name: element.plant_name, selected: false, plant_id: element.plant});
        this.siteNameListCopy.push({name: element.plant_name, selected: false, plant_id: element.plant});
        this.areaUnitList.push({name: element.unit_name, selected: false, unit_id: element.unit_unique_id});
        this.areaUnitListCopy.push({name: element.unit_name, selected: false, unit_id: element.unit_unique_id});
        this.areaCountryList.push({name: element.country_name, selected: false, country_id: element.country});
        this.areaCountryListCopy.push({name: element.country_name, selected: false, country_id: element.country});
        this.plantWiseRating.push(element); 
        return;
      }
      });
    });
    
    this.areaZoneList = Array.from(this.areaZoneList.reduce((m, t) => m.set(t.name, t), new Map()).values());
    this.areaZoneListCopy = Array.from(this.areaZoneListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());

    this.areaNameList = Array.from(this.areaNameList.reduce((m, t) => m.set(t.name, t), new Map()).values());
    this.areaNameListCopy = Array.from(this.areaNameListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());

    this.siteNameList = Array.from(this.siteNameList.reduce((m, t) => m.set(t.name, t), new Map()).values());
    this.siteNameListCopy = Array.from(this.siteNameListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());

    this.areaUnitList = Array.from(this.areaUnitList.reduce((m, t) => m.set(t.name, t), new Map()).values());
    this.areaUnitListCopy = Array.from(this.areaUnitListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());

    this.areaCountryList = Array.from(this.areaCountryList.reduce((m, t) => m.set(t.name, t), new Map()).values());
    this.areaCountryListCopy = Array.from(this.areaCountryListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());
    
    this.areaZoneList.sort((a,b) => (a.order_number) - (b.order_number));
    this.areaZoneListCopy.sort((a,b) => (a.order_number) - (b.order_number));
    
    this.areaNameList.sort((a,b) => (b.full_name) - (a.full_name));
    this.areaNameListCopy.sort((a,b) => (b.full_name) - (a.full_name));
    
    this.siteNameList.sort((a,b) => (b.name) - (a.name));
    this.siteNameListCopy.sort((a,b) => (b.name) - (a.name));
    
    this.areaUnitList.sort((a,b) => (b.name) - (a.name));
    this.areaUnitListCopy.sort((a,b) => (b.name) - (a.name));
    
    this.areaCountryList.sort((a,b) => (b.name) - (a.name));
    this.areaCountryListCopy.sort((a,b) => (b.name) - (a.name));
    
    this.orderbyRatings(this.plantWiseRating,'');
    
  
  }
  profileHeaderClick(){
    this.events.publish('profile-button-click',"");
  }
  notificationHeaderClick(){
    this.events.publish('notification-button-click',"");
  }
  async ratingDetails(name){
    let cssName:any;
    if(name==='sort'){
      cssName='open-sort-modal';
    }else{
      cssName='open-rating-info-modal';
    }
    const modal = await this.modalController.create({
      component: SiteRatingComponent,
      cssClass: cssName,
      backdropDismiss: true,
      // initialBreakpoint:0.25,
      // breakpoints:[0.25, 0.5, 0.75],
      componentProps: {
        from: name,
        userTypeRole:this.userRoleType,
        ratingSubmitted:'site-and-month',
        siteNameList:this.siteNameList,
        siteNameListCopy:this.siteNameListCopy,
        areaZoneList:this.areaZoneList,
        areaZoneListCopy:this.areaZoneListCopy,
        areaNameList:this.areaNameList,
        areaNameListCopy:this.areaNameListCopy,
        areaUnitList:this.areaUnitList,
        areaUnitListCopy:this.areaUnitListCopy,
        areaCountryList:this.areaCountryList,
        areaCountryListCopy:this.areaCountryListCopy,
        submittedDate:this.submittedDate
      }
    });
    modal.onDidDismiss().then((modelData) => {
      if(modelData.data!=null){
          if(modelData.data.sortingValue){
            this.sortingLabel=modelData.data.sortingValue;
            if(this.sortingLabel=='Sites'){
              this.areaWiseRatingList.sort((a,b) => Date.parse(b.plant) - Date.parse(a.plant));
            }else{
              this.areaWiseRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
            }
          }
          if(this.userRoleType=='country_head_of_hs'||this.userRoleType=='country_admin' ||this.userRoleType=='country_ceo'){
            if(modelData.data.submittedDate!==undefined && modelData.data.submittedDate!==null){
              let date=this.moment(modelData.data.submittedDate.dueDateTime).toISOString();
              let countryList=modelData.data.areaCountryList;
              let siteList=modelData.data.siteNameList;
              let unitList=modelData.data.areaUnitList;
              this.getFilterwithAreaNames(countryList,siteList,unitList,date);
            }
            else if(modelData.data.areaCountryList,modelData.data.siteNameList,modelData.data.areaUnitList){
              let countryList=modelData.data.areaCountryList;
              let siteList=modelData.data.siteNameList;
              let unitList=modelData.data.areaUnitList;
              this.getFilterwithAreaNames(countryList,siteList,unitList,'');
            }
            else{
              this.submittedDate='';
              this.areaZoneList=[];
              this.areaZoneListCopy=[];
              this.areaUnitList=[];
              this.areaUnitListCopy=[];
              this.siteNameList=[];
              this.siteNameListCopy=[];
              this.areaCountryList=[];
              this.areaCountryListCopy=[];
              this.areaNameList=[];
              this.areaNameListCopy=[];
              this.areaWiseRatingList=this.areaWiseRatingListCopy;
              if(this.areaWiseRatingList.length>0){
                  this.showSubmittedRatingError=false;
              }
              //this.getRatingCardList();
            }
          }
          else if(this.userRoleType=='site_manager'){
            if(modelData.data.submittedDate!==undefined && modelData.data.submittedDate!==null){
              let date=this.moment(modelData.data.submittedDate.dueDateTime).toISOString();
              let siteList=modelData.data.siteNameList;
              let areaList=modelData.data.areaNameList;
              let zoneList=modelData.data.areaZoneList;
              this.getFilterwithSiteManager(siteList,areaList,zoneList,date);
            }
            else if(modelData.data.siteNameList.length>0 && modelData.data.areaNameList.length>0 && modelData.data.areaZoneList.length>0){
              let siteList=modelData.data.siteNameList;
              let areaList=modelData.data.areaNameList;
              let zoneList=modelData.data.areaZoneList;
              this.getFilterwithSiteManager(siteList,areaList,zoneList,'');
            }
          }
          else if(this.userRoleType=='unit_manager'){
            if(modelData.data.submittedDate!==undefined && modelData.data.submittedDate!==null){
              let date=this.moment(modelData.data.submittedDate.dueDateTime).toISOString();
              let unitList=modelData.data.areaUnitList;
              let siteList=modelData.data.siteNameList;
              let areaList=modelData.data.areaNameList;
              this.getFilterwithUnitManager(unitList,siteList,areaList,date);
            }
            else if(modelData.data.areaUnitList.length>0 && modelData.data.siteNameList.length>0 && modelData.data.areaNameList){
              let unitList=modelData.data.areaUnitList;
              let siteList=modelData.data.siteNameList;
              let areaList=modelData.data.areaNameList;
              this.getFilterwithUnitManager(unitList,siteList,areaList,'');
            }
          }
          
      }
    });
    return await modal.present();
  }
  async getFilterwithAreaNames(countryList:any,siteList:any,unitList:any,date:any){
      if(this.sortingLabel=="Months"){
        this.areaWiseRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
      }
      else{
        this.areaWiseRatingList.sort((a,b) => (b.plant) - (a.plant));
      }
      let cl:any[]=[];
      countryList.forEach(element => {
        if(element.selected){
          cl.push(element);
        }
      });
      let ul:any[]=[];
      unitList.forEach(element => {
        if(element.selected){
          ul.push(element);
        }
      });
      let sl:any[]=[];
      siteList.forEach(element => {
        if(element.selected){
          sl.push(element);
        }
      });
      if(cl.length==0 && ul.length==0 && sl.length==0){
        if(date){
          let dateFilter:any[]=[];
          this.areaWiseRatingListCopy.forEach(element => {
            element['avg_rating']=Number(element.avg_rating);
            if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
              dateFilter.push(element);
              return;
            }
          });
          if(dateFilter.length==0){
            await this.getRatingListByMonth(date);  
          }else{
            this.areaWiseRatingList=dateFilter;
          }      
        }else{
          this.areaWiseRatingList=this.areaWiseRatingListCopy;
        }
      }else{
        if(cl.length>0 && ul.length==0 && sl.length==0){
          this.countryFilter(cl,date);
        }
        else if(cl.length==0 && ul.length>0 && sl.length==0){
          this.unitFilter(ul,date);
        }
        if(cl.length==0 && ul.length==0 && sl.length>0){
          this.siteFilter(sl,date);
        }
      }
      // else if(cl.length>0){
      //   this.countryFilter(cl,siteList,unitList,date);
      // }

  }

  async getFilterwithSiteManager(siteList:any,areaList:any,zoneList:any,date:any){
    if(this.sortingLabel=="Months"){
      this.areaWiseRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
    }
    else{
      this.areaWiseRatingList.sort((a,b) => (b.plant) - (a.plant));
    }
   
    let sl:any[]=[];
    siteList.forEach(element => {
      if(element.selected){
        sl.push(element);
      }
    });
    let al:any[]=[];
    areaList.forEach(element => {
      if(element.selected){
        al.push(element);
      }
    });
    let zl:any[]=[];
    zoneList.forEach(element => {
      if(element.selected){
        zl.push(element);
      }
    });
    if(zl.length==0 && sl.length==0 && al.length==0){
      if(date){
        let dateFilter:any[]=[];
        this.areaWiseRatingListCopy.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
            dateFilter.push(element);
            return;
          }
        });
        if(dateFilter.length==0){
          await this.getRatingListByMonth(date);  
        }else{
          this.areaWiseRatingList=dateFilter;
        }      
        }else{
          this.areaWiseRatingList=this.areaWiseRatingListCopy;
          // await this.getRatingListByMonth(date); 
        }
    }else{
      if(zl.length>0 && sl.length==0 && al.length==0){
        //this.zoneFilter(zl,date);
        //needs to check zoneWise

      }
      if(zl.length==0 && sl.length>0 && al.length==0){
        this.siteFilter(sl,date);
      }
      if(zl.length==0 && sl.length==0 && al.length>0){
        this.areaFilter(al,date);
      }
    }

  }
  async getFilterwithUnitManager(unitList:any,siteList:any,areaList:any,date:any){
    if(this.sortingLabel=="Months"){
      this.areaWiseRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
    }
    else{
      this.areaWiseRatingList.sort((a,b) => (b.plant) - (a.plant));
    }
    let ul:any[]=[];
    unitList.forEach(element => {
      if(element.selected){
        ul.push(element);
      }
    });
    let sl:any[]=[];
    siteList.forEach(element => {
      if(element.selected){
        sl.push(element);
      }
    });
    let al:any[]=[];
    areaList.forEach(element => {
      if(element.selected){
        al.push(element);
      }
    });
    if(ul.length==0 && sl.length==0 && al.length==0){
      if(date){
        let dateFilter:any[]=[];
        this.areaWiseRatingListCopy.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
            dateFilter.push(element);
            return;
          }
        });
        if(dateFilter.length==0){
          await this.getRatingListByMonth(date);  
        }else{
          this.areaWiseRatingList=dateFilter;
        }      
        }
        else{
          this.areaWiseRatingList=this.areaWiseRatingListCopy;
        }
    }else{
      
      if(ul.length>0 && sl.length==0 && al.length==0){
        this.unitFilter(ul,date);
      }
      if(ul.length==0 && sl.length>0 && al.length==0){
        this.siteFilter(sl,date);
      }
      if(ul.length==0 && sl.length==0 && al.length>0){
        this.areaFilter(al,date);
      }
    }
  }

  async countryFilter(countryList,date){
    let filterCountry:any[]=[];
    countryList.forEach(data => {
        this.areaWiseRatingListCopy.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(element.zone_name==data.name){
            filterCountry.push(element);
            return;
          }
        });
    });
    if(date){
      let dateFilter:any[]=[];
      this.areaWiseRatingListCopy.forEach(element => {
        element['avg_rating']=Number(element.avg_rating);
        if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
          dateFilter.push(element);
          return;
        }
      });
      this.areaWiseRatingList=dateFilter;
    }
    if(filterCountry.length>0){
       this.areaWiseRatingList=filterCountry;
    }
    if(countryList.length==0){
        if(date){
          await this.getRatingListByMonth(date);
          // if(data.length>0){
          //   this.areaWiseRatingList=data;
          //   this.areaWiseRatingListCopy=data;
          // }else{
          //   let dateFilter:any[]=[];
          //   this.areaWiseRatingList.forEach(element => {
          //     element['avg_rating']=Number(element.avg_rating);
          //     if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
          //       dateFilter.push(element);
          //       return;
          //     }
          //   });
          //   this.areaWiseRatingList=dateFilter;
          //   if(this.areaWiseRatingList.length>0){
          //     this.showSubmittedRatingError=false;
          //   }
          // }
          
        }else{
          this.submittedDate='';
          this.areaZoneList=[];
          //this.userRatingList=this.allRatingList;
         await this.getAreaRatings();
          // if(this.areaWiseRatingList.length>0){
          //   this.showSubmittedRatingError=false;
          // }
        }
      
    }
  }
  async unitFilter(unitList,date){
    let filterCountry:any[]=[];
    unitList.forEach(data => {
        this.areaWiseRatingListCopy.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(element.unit_name==data.name){
            filterCountry.push(element);
            return;
          }
        });
    });
    if(date){
      let dateFilter:any[]=[];
      this.areaWiseRatingListCopy.forEach(element => {
        element['avg_rating']=Number(element.avg_rating);
        if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
          dateFilter.push(element);
          return;
        }
      });
      this.areaWiseRatingList=dateFilter;
    }
    if(filterCountry.length>0){
       this.areaWiseRatingList=filterCountry;
    }
    if(unitList.length==0){
        if(date){
          await this.getRatingListByMonth(date);
        }else{
          this.submittedDate='';
          this.areaZoneList=[];
         await this.getAreaRatings();
        }
      
    }
  }
  async siteFilter(siteList,date){
    let filterCountry:any[]=[];
    siteList.forEach(data => {
        this.areaWiseRatingListCopy.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(element.plant==data.name){
            filterCountry.push(element);
            return;
          }
        });
    });
    if(date){
      let dateFilter:any[]=[];
      this.areaWiseRatingListCopy.forEach(element => {
        element['avg_rating']=Number(element.avg_rating);
        if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
          dateFilter.push(element);
          return;
        }
      });
      this.areaWiseRatingList=dateFilter;
    }
    if(filterCountry.length>0){
       this.areaWiseRatingList=filterCountry;
    }
    if(siteList.length==0){
        if(date){
          await this.getRatingListByMonth(date);
        }else{
          this.submittedDate='';
          this.areaZoneList=[];
         await this.getAreaRatings();
        }
      
    }
  }
  async areaFilter(siteList,date){
    let filterCountry:any[]=[];
    siteList.forEach(data => {
        this.areaWiseRatingListCopy.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(element.area_name==data.name){
            filterCountry.push(element);
            return;
          }
        });
    });
    if(date){
      let dateFilter:any[]=[];
      this.areaWiseRatingListCopy.forEach(element => {
        element['avg_rating']=Number(element.avg_rating);
        if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
          dateFilter.push(element);
          return;
        }
      });
      this.areaWiseRatingList=dateFilter;
    }
    if(filterCountry.length>0){
       this.areaWiseRatingList=filterCountry;
    }
    if(siteList.length==0){
        if(date){
          await this.getRatingListByMonth(date);
        }else{
          this.submittedDate='';
          this.areaZoneList=[];
         await this.getAreaRatings();
        }
      
    }
  }
  async zoneFilter(siteList,date){
    let filterCountry:any[]=[];
    siteList.forEach(data => {
        this.areaWiseRatingListCopy.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(element.area_name==data.full_name){
            filterCountry.push(element);
            return;
          }
        });
    });
    if(date){
      let dateFilter:any[]=[];
      this.areaWiseRatingListCopy.forEach(element => {
        element['avg_rating']=Number(element.avg_rating);
        if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
          dateFilter.push(element);
          return;
        }
      });
      this.areaWiseRatingList=dateFilter;
    }
    if(filterCountry.length>0){
       this.areaWiseRatingList=filterCountry;
    }
    if(siteList.length==0){
        if(date){
          await this.getRatingListByMonth(date);
        }else{
          this.submittedDate='';
          this.areaZoneList=[];
         await this.getAreaRatings();
        }
      
    }
  }
  getZoneFilter(zoneList,date){
    let znList:any[]=[];
    zoneList.forEach(element => {
      if(element.selected){
        znList.push(element);
      }
    });

  let filterZone:any[]=[];
  znList.forEach(data => {
        this.areaWiseRatingListCopy.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(element.zone_name==data.name){
            filterZone.push(element);
            return;
          }
        });
  });
  if(filterZone.length>0){
    this.areaWiseRatingList=filterZone;
  }
  if(date){
        let dateFilter:any[]=[];
        this.areaWiseRatingListCopy.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
            dateFilter.push(element);
            return;
          }
        });
        this.areaWiseRatingList=dateFilter;
  }
  if(this.areaWiseRatingList.length==0){
      this.showSubmittedRatingError=true;
  }
  if(znList.length==0){
      if(date){
          let dateFilter:any[]=[];
          this.areaWiseRatingListCopy.forEach(element => {
            element['avg_rating']=Number(element.avg_rating);
            if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
              dateFilter.push(element);
              return;
            }
          });
          this.areaWiseRatingList=dateFilter;
          if(this.areaWiseRatingList.length>0){
            this.showSubmittedRatingError=false;
          }
      }else{
          this.submittedDate='';
          this.areaZoneList=[];
          this.areaWiseRatingList=this.areaWiseRatingListCopy;
          if(this.areaWiseRatingList.length>0){
            this.showSubmittedRatingError=false;
          }
      }
  }
  }
  openCollapse(index){
    this.areaWiseRatingList[index].check=!this.areaWiseRatingList[index].check;
  }
  openDetails(data,index){
    this.areaService.setSelectedArea(data);
    this.router.navigate(['/area-overall-ratings-details'], {replaceUrl: true});
  }
  async orderbyRatings(siteRatings,date){
    const plantwiserating=_.groupBy(siteRatings,'plant_name');
    let plantAreaWise={};
    let plantNameList:any=[];
    let zoneList:any[];
    let innerZoneList:any=[];
    for(const plant in plantwiserating){
      plantAreaWise[plant] = {};
      let count=0;
     let plantrating = _.groupBy(plantwiserating[plant], 'area_name');
       for(let ar in plantrating) {
         let allarratings = plantrating[ar];
         let aggregated_rating =_.meanBy(plantrating[ar], (p) => p.new_avg_rating);
         const str=ar.split('- ');
        let avg_rating=_.round(aggregated_rating, 1);
        plantNameList.push({plant:plant,country_name:plantrating[ar][0].country_name,unit_name:plantrating[ar][0].unit_name,check:false,
          area_name:str[1],avg_rating:avg_rating,submitted_date:plantrating[ar][0].submitted_date,zone_list:{}});
         plantAreaWise[plant][ar] = {
          avg_ratings: avg_rating,
        }
          zoneList = _.groupBy(allarratings, 'zone_name');
          let groupByData:any[]=[];
          for(let zr in zoneList){
            let aggregated_zone_rating=_.meanBy(zoneList[zr], (p) => p.new_avg_rating);
            aggregated_zone_rating=_.round(aggregated_zone_rating, 1);
          let exists =  _.filter(zoneList[zr], (z) => {
              return z.area_name == zoneList[zr].area_name;
          });
          if(exists.length >0)
          {
            let index= groupByData.findIndex((bb) => bb.area_owner_name === zoneList[zr].area_owner_name);
            groupByData[index]=zoneList[zr];
          }
          else {
            groupByData.push(zoneList[zr]);
          }
            let object={
              zone_details_ratings: aggregated_zone_rating,
              zone_name:zoneList[zr][0].zone_name,
              all_zone_ratings: zoneList[zr]
            }
            innerZoneList.push(object);
          }
          plantNameList[count].zone_list=innerZoneList;
          count++;
          
       }
       
    }
    if(plantNameList.length>0){
      this.areaWiseRatingList=[];
      this.areaWiseRatingListCopy=[];
     if(date!=''){
      plantNameList.forEach(element => {
        if(element.area_name!=undefined){
          if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
            this.areaWiseRatingList.push(element);
            this.areaWiseRatingListCopy.push(element);
          }
        }
        
      });
     }else{
      plantNameList.forEach(element => {
        if(element.area_name!=undefined){
          if(new Date().getMonth()===new Date(element.submitted_date).getMonth()){
            this.areaWiseRatingList.push(element);
            this.areaWiseRatingListCopy.push(element);
          }
        }
      });
     }
      setTimeout(()=>{
        this.areaWiseRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
        this.areaWiseRatingListCopy.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
      },1000);
    }
  }
  async new_orderbyRatings(siteRatings,date){
    const plantwiserating=_.groupBy(siteRatings,'plant_name');
    let plantAreaWise={};
    let plantNameList:any=[];
    for(const plant in plantwiserating){
      plantAreaWise[plant] = {};
      let count=0;
      let aggregated_rating=0;
      let zonerating = _.groupBy(plantwiserating[plant], 'zone_name');
        for(let zn in zonerating) {
            aggregated_rating=_.meanBy(zonerating[zn], (p) => p.new_avg_rating);
            aggregated_rating=_.round(aggregated_rating, 1)
            let ar_name=zonerating[zn][count].area_name;
            const str=ar_name.split('- ');
            plantNameList.push({area_name:str[1],full_name:ar_name,plant:plant,zone_name:zonerating[zn][count].zone_name,check:false,
              avg_rating:aggregated_rating,submitted_date:zonerating[zn][0].submitted_date,
            zone_num:zonerating[zn][count].zone_num,
            country:zonerating[zn][count].country_name,
            unit:zonerating[zn][count].unit_name,
          zone_list:{all_zone_ratings: zonerating[zn]}});
            count++; 
        } 
    }

    if(plantNameList.length>0){
      this.areaWiseRatingList=[];
      this.areaWiseRatingListCopy=[];
     if(date!=''){
      plantNameList.forEach(element => {
        if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
          this.areaWiseRatingList.push(element);
          this.areaWiseRatingListCopy.push(element);
        }
      });
     }else{
      plantNameList.forEach(element => {
        if(new Date().getMonth()===new Date(element.submitted_date).getMonth()){
          this.areaWiseRatingList.push(element);
          this.areaWiseRatingListCopy.push(element);
        }
      });
     }
      setTimeout(()=>{
        this.areaWiseRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
        this.areaWiseRatingListCopy.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
        
      },1000);
    }
  }
  dismiss(){
    this.modalController.dismiss();
  }
  async getRatingListByMonth(date){
    let plant=this.plantNameList[0];
    let docData:any[]=[];
    let currentMonth:any[]=[];
    let docInfo = await this.lhFirebaseService.queryCollection('area_management_ratings',where("plant_name", '==', plant.name)
     //.where("area_owner_email", '==', this.service.appData.userInfo.email)
    //.where("email", '==', this.service.appData.userInfo.email)
    )
    docInfo.docs?.forEach((doc: any) => {
      currentMonth.push(doc.data());
    })
    currentMonth.forEach(element => {
      if(element.category==undefined){
        element['category']='Industrial';
      }else{
        if(element.category==this.typeName && new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){ 
          docData.push(element);
        }
      }
    });
    if(docData.length>0){
      this.areaZoneList=[];
      this.areaZoneListCopy=[];
      docData.forEach(element => {  
        element['month_and_year'] = new Date(element.submitted_date).toLocaleDateString('en-GB', {
          month : 'long',
          year : 'numeric'
        }).split(' ').join('/');
        const str=(element.area_name).split('- ');
        const zone_num=(element.zone_name).split(' ');
        element['zone_num']=Number(zone_num[1]);
        element['full_name']=str[1];
        element['new_avg_rating']=parseFloat(element.avg_rating);
        this.areaZoneList.push({check: true, name: element.zone_name, selected: false, order_number: element.zone_num});
      this.areaZoneListCopy.push({check: true, name: element.zone_name, selected: false, order_number: element.zone_num});
      this.areaNameList.push({check: true, name: element.full_name, selected: false, full_name: element.area_name});
      this.areaNameListCopy.push({check: true, name: element.full_name, selected: false, full_name: element.area_name});
      this.siteNameList.push({name: element.plant_name, selected: false, plant_id: element.plant});
      this.siteNameListCopy.push({name: element.plant_name, selected: false, plant_id: element.plant});
      this.areaUnitList.push({name: element.unit_name, selected: false, unit_id: element.unit_unique_id});
      this.areaUnitListCopy.push({name: element.unit_name, selected: false, unit_id: element.unit_unique_id});
      this.areaCountryList.push({name: element.country_name, selected: false, country_id: element.country});
      this.areaCountryListCopy.push({name: element.country_name, selected: false, country_id: element.country});

        
      });
      this.areaZoneList = Array.from(this.areaZoneList.reduce((m, t) => m.set(t.name, t), new Map()).values());
      this.areaZoneListCopy = Array.from(this.areaZoneListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());
  
      this.areaNameList = Array.from(this.areaNameList.reduce((m, t) => m.set(t.name, t), new Map()).values());
      this.areaNameListCopy = Array.from(this.areaNameListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());
  
      this.siteNameList = Array.from(this.siteNameList.reduce((m, t) => m.set(t.name, t), new Map()).values());
      this.siteNameListCopy = Array.from(this.siteNameListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());
  
      this.areaUnitList = Array.from(this.areaUnitList.reduce((m, t) => m.set(t.name, t), new Map()).values());
      this.areaUnitListCopy = Array.from(this.areaUnitListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());
  
      this.areaCountryList = Array.from(this.areaCountryList.reduce((m, t) => m.set(t.name, t), new Map()).values());
      this.areaCountryListCopy = Array.from(this.areaCountryListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());
      
      this.areaZoneList.sort((a,b) => (a.order_number) - (b.order_number));
      this.areaZoneListCopy.sort((a,b) => (a.order_number) - (b.order_number));
      
      this.areaNameList.sort((a,b) => (b.full_name) - (a.full_name));
      this.areaNameListCopy.sort((a,b) => (b.full_name) - (a.full_name));
      
      this.siteNameList.sort((a,b) => (b.name) - (a.name));
      this.siteNameListCopy.sort((a,b) => (b.name) - (a.name));
      
      this.areaUnitList.sort((a,b) => (b.name) - (a.name));
      this.areaUnitListCopy.sort((a,b) => (b.name) - (a.name));
      
      this.areaCountryList.sort((a,b) => (b.name) - (a.name));
      this.areaCountryListCopy.sort((a,b) => (b.name) - (a.name));
      this.orderbyRatings(docData,date);
    }
    //return docData;
  }
  async getAreaRatings(){
    let plant=this.plantNameList[0];
    let docData:any[]=[];
    let currentMonth:any[]=[];
    let docInfo = await this.lhFirebaseService.queryCollection('area_management_ratings',where("plant", '==', plant.name)
    //.where("email", '==', this.service.appData.userInfo.email)
    )
    docInfo.docs?.forEach((doc: any) => {
      currentMonth.push(doc.data());
    })
    
    currentMonth.forEach(element => {
      if(new Date().getMonth()===new Date(element.submitted_date).getMonth()){
        if(element.category==undefined){
          element['catgeory']='Industrial';
        }
        docData.push(element);
      }
    });
    docData.forEach(element => {  
      element['month_and_year'] = new Date(element.submitted_date).toLocaleDateString('en-GB', {
        month : 'long',
        year : 'numeric'
      }).split(' ').join('/');
      const str=(element.area_name).split('- ');
      const zone_num=(element.zone_name).split(' ');
      element['zone_num']=Number(zone_num[1]);
      element['full_name']=str[1];
      element['new_avg_rating']=parseFloat(element.avg_rating);
    });
    this.ionViewWillEnter();
  //return docData;
  }

  async loadMoreSiteData(site_data) {
    //let paginationData:any[]=[];
    let firstTimeAPICall: boolean = true;
    if(this.last_document.length > 0){
      firstTimeAPICall = false;
    }
    if(firstTimeAPICall){
      this.isAreaLoaded = true;
      this.isMySitedataLoaded = true;
    }
    let temp_mysite_data : any[] = [];
    //let last_doc;
    let last_doc;
    if(this.last_document.length > 0){
      let rdata: any = await this.getRatingList(this.plantNameList[0], this.last_document[0]);
      temp_mysite_data = rdata.docData;
      last_doc = rdata.lastVisible;
    }else{
      let rdata: any = await this.getRatingList(this.plantNameList[0], '');
      temp_mysite_data = rdata.docData;
      last_doc = rdata.lastVisible;
    }
    if(temp_mysite_data.length > 0){
      console.log(last_doc)
      this.last_document[0] = last_doc;
    }
    if(firstTimeAPICall){
      this.paginationData = temp_mysite_data;
      this.isAreaLoaded = false;
      this.isMySitedataLoaded = false;
    }else{
      this.paginationData = [...this.paginationData, ...temp_mysite_data];
    }
    console.log("this.paginationData ::",this.paginationData);
  }
  async getRatingList(data,last_document){
    console.log("data",data.name);
    let docData = [];
    let docInfo;
    if(last_document != ''){  
      docInfo = await this.lhFire.queryCollection('area_management_ratings',orderBy("submitted_date", "desc")
      ,where("plant_name", 'in', data.name)
      ,where("status", '==', "active")
      ,startAfter(last_document)
      ,limit(50)
    )
      // docInfo = await this.lhFire.collection('area_management_ratings').ref
      // .orderBy("submitted_date", "desc")
      // .where("plant_name", 'in', data.name)
      // .where("status", '==', "active")
      // .startAfter(last_document)
      // .limit(50)
      // .get();
    }else{
      docInfo = await this.lhFire.queryCollection('area_management_ratings',orderBy("submitted_date", "desc")
      ,where("plant_name", 'in', data.name)
      ,where("status", '==', "active")
      ,limit(50)
     )
      // docInfo = await this.lhFire.collection('area_management_ratings').ref
      // .orderBy("submitted_date", "desc")
      // .where("plant_name", 'in', data.name)
      // .where("status", '==', "active")
      // .limit(50)
      // .get();
    }
    const lastVisible = docInfo.docs[docInfo.docs.length - 1];
    docInfo.docs?.forEach((doc: any) => {
      docData.push(doc.data());
    });
    
    return { docData: docData, lastVisible: lastVisible };
  }
}
